import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { List } from "@material-ui/core";
import DashboardIcon from "@material-ui/icons/Dashboard";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ScheduleIcon from '@material-ui/icons/Schedule';
import NavLink from "../NavLink";

import { styles } from "./Sidebar.styles";

function Sidebar({ classes, onSelect }) {
 // const [subMenuOpen, setSubMenuOpen] = useState(false);

  return (
    <List>
      <NavLink
        activeClass={classes.active}
        icon={<DashboardIcon />}
        primary="Dashboard"
        to="/dashboard"
        onClick={onSelect}
      />
      <NavLink
        activeClass={classes.active}
        icon={<NotificationsActiveIcon />}
        primary="Alerts"
        to="/alerts"
        onClick={onSelect}
      />
      <NavLink
        activeClass={classes.active}
        icon={<AccountTreeIcon />}
        primary="Structure"
        to="/structure"
        onClick={onSelect}
      />
      <NavLink
        activeClass={classes.active}
        icon={<ScheduleIcon />}
        primary="Schedules"
        to="/schedules"
        onClick={onSelect}
      />
      <NavLink
        activeClass={classes.active}
        icon={<AssignmentIcon />}
        primary="Logs"
        to="/logs"
        onClick={onSelect}
      />
      {/* <NavLink
        activeClass={classes.active}
        icon={<NotificationsActiveIcon />}
        primary="Settings"
        onClick={handleConfigSubmenu}
      >
        {subMenuOpen ? <ExpandLess /> : <ExpandMore />}
      </NavLink>
      <List>
        <Collapse in={subMenuOpen} timeout="auto" unmountOnExit>
          <NavLink
            icon={<NotificationsActiveIcon />}
            primary="Structure"
            to="/structure"
          />
        </Collapse>
      </List> */}
    </List>
  );
}

export default withStyles(styles)(Sidebar);
